import type * as React from 'react';
import { animated as a } from 'react-spring';
import styled from 'styled-components';
import tw from 'twin.macro';

import ArrowDown from '@/icons/dropdown.svg?react';

export type AnimatedDownArrowType = {
  /**
   * should not animate the arrow
   */
  noAnimation?: boolean;
  /**
   * icon size
   */
  size?: 'medium' | 'small';
  /**
   * animate style props from react-spring
   */
  style?: React.CSSProperties;
};

const AnimatedArrowContainer = styled(a.span)<
  Pick<AnimatedDownArrowType, 'size'>
>`
  ${tw`w-4 h-4 text-gray-900`}
  ${({ size }) => size === 'medium' && tw`w-6 h-6`}
`;

export const AnimatedDownArrow = ({
  noAnimation,
  size = 'small',
  style = {},
}: AnimatedDownArrowType): JSX.Element => {
  return (
    <AnimatedArrowContainer
      {...(!noAnimation && { style })}
      size={size}
      data-dropdown-arrow
      aria-hidden
    >
      <ArrowDown className='fill-current' />
    </AnimatedArrowContainer>
  );
};
